export default __webpack_public_path__ + "static/media/data-extractionImg.366e1be6.svg";